/**
 * Absolute, clickable URLs for the customer-facing pages the studio sends out.
 *
 * These links are embedded in outbound message TEXT the customer taps on their own
 * phone (an SMS / DM), so they must be full origin-qualified URLs — a bare
 * app-relative path like `/customer-deposit/<id>` isn't tappable outside the app
 * (tv-064.1). The current origin is used, so the link resolves to staging on
 * staging and to the dev host locally, with no build-time base URL to keep in sync.
 */

/** Origin the customer app is served from ('' in a non-browser context / tests
 *  where window is stubbed without a location). */
function appOrigin(): string {
  return typeof window !== 'undefined' && window.location ? window.location.origin : '';
}

/** Absolute URL for the deposit pay page (`/customer-deposit/:depositId`). */
export function customerDepositUrl(depositId: string): string {
  return `${appOrigin()}/customer-deposit/${depositId}`;
}
